export default {"src":"/_next/static/media/applications.ec3b081b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};